'use strict';

( function( $ ) {
	class Pagination {
		constructor( $component ) {
			this.$pagination = $component;
			this.$select = $component.find( '[data-pagination="select"]' );

			this.init = this.init.bind( this );

			this.init();
		}

		init() {
			this.$select.on( 'change', e => {
				window.location.href = e.target.value;
			} );
		}
	}

	$.fn.pagination = function() {
		this.each( function() {
			new Pagination( $( this ) );
		} );
	};

	$( '[data-pagination="component"]' ).pagination();
}( jQuery ) );

// Not taller than window
// fixed to side of page .fixed-top
// positioned bottom of content .position-bottom

// Taller than window
// fixed to bottom of page .fixed-bottom
// positioned bottom of content .position-bottom
const stickySidebar = $ => {
	const $sidebar = $( '#sticky-sidebar' );
	const $sidebarContent = $sidebar.find( '.sidebar-content' );
	const $content = $( '#page-content > .content-wrapper' );
	let isVisible, viewportHeight, sidebarContentHeight, contentHeight, sidebarNeedsToScroll, sidebarNeedsToPosition, windowPos;

	const getViewportHeight = () => {
		const offset = parseInt( $( 'body' ).css( 'padding-top' ).replace( 'px', '' ) );
		const windowHeight = window.innerHeight;

		return windowHeight - offset;
	};

	const setVars = () => {
		isVisible = $sidebar.css( 'display' ) === 'none' ? false : true;
		viewportHeight = getViewportHeight();
		sidebarContentHeight = $sidebarContent.outerHeight();
		contentHeight = $content.outerHeight();
		sidebarNeedsToPosition = contentHeight > viewportHeight ? true : false;
		sidebarNeedsToScroll = sidebarContentHeight > viewportHeight && contentHeight > viewportHeight ? true : false;
	};

	const onScroll = () => {
		windowPos = $( window ).scrollTop();
		setSidebar();
	};

	const setSidebar = () => {
		if ( ! isVisible ) {
			return;
		}

		if ( ! sidebarNeedsToPosition && ! sidebarNeedsToScroll ) {
			return;
		}

		if ( sidebarNeedsToScroll ) {
			setTallSidebar();
			return;
		}

		if ( sidebarNeedsToPosition ) {
			setStandardSidebar();
		}
	};

	const setStandardSidebar = () => {
		if ( ! isFooterVisible() && ! $sidebarContent.hasClass( 'fixed-top' ) ) {
			removeClasses();
			$sidebarContent.addClass( 'fixed-top' );
		}

		if ( isFooterVisible() && ! $sidebarContent.hasClass( 'position-bottom' ) ) {
			removeClasses();
			$sidebarContent.addClass( 'position-bottom' );
		}
	};

	const setTallSidebar = () => {
		// Fix to bottom of screen if passed scroll point and footer not visible
		if ( isSidebarBottomVisible() && ! isFooterVisible() && ! isSidebarAttached() ) {
			removeClasses();
			$sidebarContent.addClass( 'fixed-bottom' );
		}

		// Position to bottom when scrolling down and footer is visible
		if ( isSidebarAttached() && isFooterVisible() ) {
			removeClasses();
			$sidebarContent.addClass( 'position-bottom' );
		}

		// Fix to bottom when scrolling up and footer no longer visible
		if ( $sidebarContent.hasClass( 'position-bottom' ) && ! isFooterVisible() ) {
			removeClasses();
			$sidebarContent.addClass( 'fixed-bottom' );
		}

		// Return to normal position if bottom of sidebar no long supposed to be visible on scroll up
		if ( ! isSidebarBottomVisible() && $sidebarContent.hasClass( 'fixed-bottom' ) ) {
			$sidebarContent.removeClass( 'fixed-bottom' );
		}
	};

	const removeClasses = () => {
		$sidebarContent.removeClass( 'fixed-top position-bottom fixed-bottom' );
	};

	const isSidebarAttached = () => {
		return $sidebarContent.hasClass( 'fixed-top' ) || $sidebarContent.hasClass( 'fixed-bottom' ) || $sidebarContent.hasClass( 'position-bottom' ) ? true : false;
	};

	const isFooterVisible = () => {
		const footerPos = contentHeight - ( viewportHeight + windowPos );
		return footerPos > 0 ? false : true;
	};

	const isSidebarBottomVisible = () => {
		return windowPos - ( sidebarContentHeight - viewportHeight ) >= 0 ? true : false;
	};

	return {
		init() {
			$( window ).load( () => {
				setVars();
				onScroll();
				this.bind();
			} );
		},
		bind() {
			$( window ).on( 'scroll', () => {
				onScroll();
			} );

			$( window ).on( 'resize', () => {
				setVars();
				onScroll();
			} );
		}
	};
};

stickySidebar( jQuery ).init();

const sidebarNav = $ => {
	const keyboard = {
		tab: 9,
		escape: 27,
		space: 32,
		up: 38,
		down: 40,
		left: 37,
		right: 39
	};

	const showNavOnHover = ( e ) => {
		const $toggle = $( e.currentTarget );
		const $subnav = $( `#${ $toggle.attr( 'aria-controls' ) }` );

		if ( $subnav.attr( 'aria-expanded' ) === 'true' ) {
			return;
		}

		showNav( $subnav );
		$subnav.on( 'mouseleave', () => {
			hideNav( $subnav );
		} );
	};

	const hideNavOnHoverOut = ( e ) => {
		const $toggle = $( e.currentTarget );
		const subnavId = $toggle.attr( 'aria-controls' );
		const $subnav = $( `#${ subnavId }` );

		if ( $subnav.attr( 'aria-expanded' ) === 'false' ) {
			return;
		}

		const $target = $( e.relatedTarget );

		if ( $target.attr( 'id' ) === subnavId ) {
			return;
		}

		if ( $target.parents( `#${ subnavId }` ).length ) {
			return;
		}

		hideNav( $subnav );
		$subnav.off( 'mouseleave' );
	};

	const showNav = ( $subnav, focus = false ) => {
		const $toggle = $( `#${ $subnav.attr( 'aria-labelledby' ) }` );

		$subnav
			.addClass( 'nav-visible' )
			.animate( { now: '+=100' }, {
				duration: 250,
				step( now ) {
					$subnav.css( 'transform', `translateX(${ now }%)` );
				},
				complete() {
					this.now = 0;

					$subnav
						.addClass( 'nav-extended' )
						.removeAttr( 'style' );

					$toggle.attr( 'aria-expanded', 'true' );

					if ( focus ) {
						$subnav.find( '.submenu-link' ).first().focus();
					}
				}
			} );
	};

	const hideNav = ( $subnav ) => {
		const $toggle = $( `#${ $subnav.attr( 'aria-labelledby' ) }` );

		$subnav
			.css( 'transform', 'translateX(100%)' )
			.removeClass( 'nav-extended' )
			.animate( { now: '+=100' }, {
				duration: 250,
				step( now ) {
					$subnav.css( 'transform', `translateX(${ 100 - now }%)` );
				},
				complete() {
					this.now = 0;

					$subnav
						.removeClass( 'nav-visible' )
						.removeAttr( 'style' );

					$toggle.attr( 'aria-expanded', 'false' );
				}
			} );
	};

	const navFocusNext = ( $currentEl ) => {
		const $nextEl = $currentEl.parent().next();

		if ( $nextEl.length ) {
			$nextEl.find( 'a' ).focus();
			return;
		}

		$( '.sidebar-link' ).first().focus();
	};

	const navFocusPrev = ( $currentEl ) => {
		const $nextEl = $currentEl.parent().prev();

		if ( $nextEl.length ) {
			$nextEl.find( 'a' ).focus();
			return;
		}

		$( '.sidebar-link' ).last().focus();
	};

	const showNavOnFocus = ( $currentEl ) => {
		const $subnav = $( `#${ $currentEl.attr( 'aria-controls' ) }` );
		showNav( $subnav, true );
	};

	const subnavFocusNext = ( $currentEl ) => {
		const $nextEl = $currentEl.parent().next();

		if ( $nextEl.length ) {
			$nextEl.find( 'a' ).focus();
			return;
		}

		$currentEl.closest( '.submenu' ).find( 'a' ).first().focus();
	};

	const subnavFocusPrev = ( $currentEl ) => {
		const $nextEl = $currentEl.parent().prev();

		if ( $nextEl.length ) {
			$nextEl.find( 'a' ).focus();
			return;
		}

		$currentEl.closest( '.submenu' ).find( 'a' ).last().focus();
	};

	const navFocusBack = ( $currentEl ) => {
		const $subnav = $currentEl.closest( '.sidebar-subnav' );
		const $toggle = $( `#${ $subnav.attr( 'aria-labelledby' ) }` );

		$toggle.focus();
		hideNav( $subnav );
	};

	return {
		init() {
			this.bind();
		},
		bind() {
			$( '.sidebar-link.has-subnav' ).on( 'mouseenter', ( e ) => {
				showNavOnHover( e );
			} );

			$( '.sidebar-link.has-subnav' ).on( 'mouseout', ( e ) => {
				hideNavOnHoverOut( e );
			} );

			// Main nav links
			$( '.sidebar-link' ).on( 'keydown', ( e ) => {
				const $link = $( e.currentTarget );
				const hasSubmenu = $link.hasClass( 'has-subnav' );

				// Focus next element on down key
				if ( ( e.keyCode === keyboard.down ) ) {
					e.preventDefault();
					navFocusNext( $link );
				}

				// Focus prev element on up key
				if ( ( e.keyCode === keyboard.up ) ) {
					e.preventDefault();
					navFocusPrev( $link );
				}

				if ( ! hasSubmenu ) {
					return;
				}

				// Open subnav
				if ( e.keyCode === keyboard.space || e.keyCode === keyboard.right ) {
					e.preventDefault();
					showNavOnFocus( $link );
				}
			} );

			// Main nav links
			$( '.sidebar-link' ).on( 'click', ( e ) => {
				const $link = $( e.currentTarget );
				const href = $link.attr( 'href' );

				if ( href === '#' ) {
					e.preventDefault();
					return;
				}
			} );

			// Subpage links
			$( '.submenu-link' ).on( 'keydown', ( e ) => {
				const $link = $( e.currentTarget );

				// Focus next element on down key
				if ( ( e.keyCode === keyboard.down ) ) {
					e.preventDefault();
					subnavFocusNext( $link );
				}

				// Focus prev element on up key
				if ( ( e.keyCode === keyboard.up ) ) {
					e.preventDefault();
					subnavFocusPrev( $link );
				}

				// Return to main nav on left key
				if ( ( e.keyCode === keyboard.left ) ) {
					e.preventDefault();
					navFocusBack( $link );
				}
			} );

			$( document ).on( 'keydown', ( e ) => {
				const $subnav = $( '.sidebar-subnav.nav-extended' );

				if ( ( e.keyCode === keyboard.escape && $subnav.length ) ) {
					e.preventDefault();
					const $toggle = $( `#${ $subnav.attr( 'aria-labelledby' ) }` );
					$toggle.focus();
					hideNav( $subnav );
				}
			} );
		}
	};
};

sidebarNav( jQuery ).init();

const blogCarousel = $ => {
	const $carousel = $( '#blog-carousel .carousel-main' );
	const prevArrow =
		`<button class="control-arrow control-prev" type="button">
			<span class="sr-only">Previous</span>
			<i class="fas fa-arrow-left" aria-hidden="true"></i>
		</button>`;
	const nextArrow =
		`<button class="control-arrow control-next" type="button">
			<span class="sr-only">Next</span>
			<i class="fas fa-arrow-right" aria-hidden="true"></i>
		</button>`;
	const options = {
		arrows: true,
		prevArrow,
		nextArrow,
		dots: true,
		slidesToShow: 3,
		appendArrows: '#carousel-controls',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};

	return {
		init() {
			if ( ! $carousel.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$carousel.slick( options );
		}
	};
};

blogCarousel( jQuery ).init();

const podcastCarousel = $ => {
	const breakpoint = 768;
	let lastWidth = window.innerWidth;
	const $carouselMain = $( '#podcast-carousel .carousel-main .feed-wrapper' );
	const $carouselPreview = $( '#podcast-carousel .carousel-preview .feed-wrapper' );
	const prevArrow =
		`<button class="control-arrow control-prev" type="button">
			<span class="sr-only">Previous</span>
			<i class="fas fa-arrow-left" aria-hidden="true"></i>
		</button>`;
	const nextArrow =
		`<button class="control-arrow control-next" type="button">
			<span class="sr-only">Next</span>
			<i class="fas fa-arrow-right" aria-hidden="true"></i>
		</button>`;
	const carouselMainOptions = {
		arrows: false,
		dots: false,
		slidesToShow: 1,
		fade: true,
		swipe: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: true,
					fade: false,
					swipe: true
				}
			}
		]
	};
	const carouselPreviewOptions = {
		arrows: true,
		prevArrow,
		nextArrow,
		dots: true,
		slidesToShow: 2,
		appendArrows: '#carousel-controls',
		swipe: false,
		initialSlide: 0
	};

	const init = ( ) => {
		// Init preview carousel to sync with main caousel
		const slideIndex = $carouselMain.find( '.slick-current' ).data( 'slick-index' );
		const currentIndex = slideIndex ? slideIndex : 0;
		carouselPreviewOptions.initialSlide = currentIndex;
		$carouselPreview.slick( carouselPreviewOptions );

		$carouselPreview.on( 'beforeChange', ( e, slick, currentSlide, nextSlide ) => {
			$carouselMain.slick( 'slickGoTo', parseInt( nextSlide ) );
		} );
	};

	const destroy = () => {
		$carouselPreview.slick( 'unslick' );
	};

	const resize = () => {
		const currentWidth = window.innerWidth;
		const expanding = currentWidth > lastWidth ? true : false;
		let crossBreakpoint = false;

		if ( expanding && currentWidth >= breakpoint && lastWidth < breakpoint ) {
			crossBreakpoint = true;
		}

		if ( ! expanding && currentWidth < breakpoint && lastWidth >= breakpoint ) {
			crossBreakpoint = true;
		}

		if ( expanding && crossBreakpoint ) {
			init();
		}

		if ( ! expanding && crossBreakpoint ) {
			destroy();
		}

		lastWidth = currentWidth;
	};

	return {
		init() {
			if ( ! $carouselMain.length ) {
				return;
			}

			if ( lastWidth >= breakpoint ) {
				init();
			}

			this.bind();
		},
		bind() {
			$carouselMain.slick( carouselMainOptions );

			$carouselMain.on( 'beforeChange', ( e, slick, currentSlide, nextSlide ) => {
				if ( lastWidth >= breakpoint ) {
					$carouselPreview.slick( 'slickGoTo', parseInt( nextSlide ) );
				}
			} );

			$( window ).resize( resize );
		}
	};
};

podcastCarousel( jQuery ).init();

const studentCarousel = $ => {
	const breakpoint = 768;
	let lastWidth = window.innerWidth;
	const $carouselMain = $( '#student-carousel .carousel-main .feed-wrapper' );
	const $carouselPreview = $( '#student-carousel .carousel-preview .feed-wrapper' );
	const prevArrow =
		`<button class="control-arrow control-prev" type="button">
			<span class="sr-only">Previous</span>
			<i class="fas fa-arrow-left" aria-hidden="true"></i>
		</button>`;
	const nextArrow =
		`<button class="control-arrow control-next" type="button">
			<span class="sr-only">Next</span>
			<i class="fas fa-arrow-right" aria-hidden="true"></i>
		</button>`;
	const carouselMainOptions = {
		arrows: false,
		dots: false,
		slidesToShow: 1,
		fade: true,
		swipe: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: true,
					fade: false,
					swipe: true
				}
			}
		]
	};
	const carouselPreviewOptions = {
		arrows: true,
		prevArrow,
		nextArrow,
		dots: true,
		slidesToShow: 2,
		appendArrows: '#carousel-controls',
		swipe: false,
		initialSlide: 0
	};

	const init = ( ) => {
		// Init preview carousel to sync with main caousel
		const slideIndex = $carouselMain.find( '.slick-current' ).data( 'slick-index' );
		const currentIndex = slideIndex ? slideIndex : 0;
		carouselPreviewOptions.initialSlide = currentIndex;
		$carouselPreview.slick( carouselPreviewOptions );

		$carouselPreview.on( 'beforeChange', ( e, slick, currentSlide, nextSlide ) => {
			$carouselMain.slick( 'slickGoTo', parseInt( nextSlide ) );
		} );
	};

	const destroy = () => {
		$carouselPreview.slick( 'unslick' );
	};

	const resize = () => {
		const currentWidth = window.innerWidth;
		const expanding = currentWidth > lastWidth ? true : false;
		let crossBreakpoint = false;

		if ( expanding && currentWidth >= breakpoint && lastWidth < breakpoint ) {
			crossBreakpoint = true;
		}

		if ( ! expanding && currentWidth < breakpoint && lastWidth >= breakpoint ) {
			crossBreakpoint = true;
		}

		if ( expanding && crossBreakpoint ) {
			init();
		}

		if ( ! expanding && crossBreakpoint ) {
			destroy();
		}

		lastWidth = currentWidth;
	};

	return {
		init() {
			if ( ! $carouselMain.length ) {
				return;
			}

			if ( lastWidth >= breakpoint ) {
				init();
			}

			this.bind();
		},
		bind() {
			$carouselMain.slick( carouselMainOptions );

			$carouselMain.on( 'beforeChange', ( e, slick, currentSlide, nextSlide ) => {
				if ( lastWidth >= breakpoint ) {
					$carouselPreview.slick( 'slickGoTo', parseInt( nextSlide ) );
				}
			} );

			$( window ).resize( resize );
		}
	};
};

studentCarousel( jQuery ).init();

const feedFiltersToggle = $ => {
	const $feed = $( '#filtered-feed' );
	let $toggle, $collapse;

	const toggle = () => {
		if ( $toggle.hasClass( 'animating' ) ) {
			return;
		}

		if ( $toggle.attr( 'aria-expanded' ) === 'false' ) {
			expand();
		} else {
			collapse();
		}
	};

	const expand = () => {
		$toggle.addClass( 'animating' );

		$collapse.css( {
			display: 'block',
			height: 0
		} );

		$feed.removeClass( 'collapsed-filters' );

		const height = $collapse.get( 0 ).scrollHeight;

		$collapse.animate( {
			height
		}, 300, () => {
			$toggle
				.removeClass( 'animating' )
				.attr( 'aria-expanded', 'true' );

			$collapse.removeAttr( 'style' );

			window.dispatchEvent( new Event( 'resize' ) );
		} );
	};

	const collapse = () => {
		$toggle.addClass( 'animating' );

		const height = $collapse.get( 0 ).scrollHeight;

		$collapse.css( {
			display: 'block',
			height
		} );

		$feed.addClass( 'collapsed-filters' );

		$collapse.animate( {
			height: 0
		}, 300, () => {
			$toggle
				.removeClass( 'animating' )
				.attr( 'aria-expanded', 'false' );

			$collapse.removeAttr( 'style' );

			window.dispatchEvent( new Event( 'resize' ) );
		} );
	};

	return {
		init() {
			if ( ! $feed.length ) {
				return;
			}

			$toggle = $feed.find( '[data-feed="toggle"]' );
			$collapse = $feed.find( '[data-feed="collapse"]' );

			this.bind();
		},
		bind() {
			$toggle.on( 'click', () => {
				toggle();
			} );
		}
	};
};

feedFiltersToggle( jQuery ).init();

const mapSelect = $ => {
	const $mapDisplay = $( '#map-display' );

	const toggleDisplay = ( id ) => {
		updateMap( id );
		$( '#state-select' ).val( id );
		updateFeed( id );
	};

	const updateMap = ( id ) => {
		$( '#research-map > .state.active' ).removeClass( 'active' );
		$( '#research-map  #' + id ).addClass( 'active' );
	};

	const updateFeed = ( id ) => {
		if (id === 'na') {
			$( '.map-card' ).show();
			console.log(id);
		} else {
			$( '.map-card' ).hide().filter('[data-state="' + id + '"]').show();
			if ($( '.map-card' ).filter('[data-state="' + id + '"]').length > 0) {
				$( '.no-results' ).hide();
			} else {
				$( '.no-results' ).show();
			}
		}
	};

	return {
		init() {
			if ( ! $mapDisplay.length ) {
				return;
			}

			this.bind();
		},
		bind() {
			$( '#research-map > .state' ).on( 'click', function( e ) {
				toggleDisplay( e.target.id );
			} );

			$( '#state-select' ).on( 'change', function() {
				toggleDisplay( this.value );
			} );
		}
	};
};

mapSelect( jQuery ).init();

const filterFeed = $ => {
	let issue, category, author, card_type, base_url, pt;
	const spinner = `<div class="sk-chase">
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						</div>`;

	// Get Filter Values to sort list and map
	const setFilters = () => {
		issue = $('input:checkbox[name="issue_area"]:checked').map(function() {
			return this.value;
		}).get();
		category = $('.checkbox-filter input:checkbox[name="content_types"]:checked').map(function() {
			return this.value;
		}).get();
		if (category.length === 0) {
			console.log('no cat');
			category = window.content_types;
			console.log(category);
		}
		author = $('#author_filter').val();
	};

	const clearFilters = () => {
		$('input:checkbox[name="content_types"]').prop( "checked", false );
		$('input:checkbox[name="issue_area"]').prop( "checked", false );
		$('#author_filter').val(0);
		$('#school_filter').val(0);
	};

	// Get HTML
	const getData = () => {
		return new Promise( ( resolve, reject ) => {
			$.ajax( {
				type: 'GET',
				url: '/wp-json/wp/v2/filterfeed',
				data: {
					'action' : 'rest_re_get_posts',
					'issue' : issue,
					'category' : category,
					'sf_author' : author,
					'card_type' : card_type,
					'base_url': base_url,
					'pt': pt,
				},
				success: response => {
					return resolve( response );
				},
				error: response => {
					return reject( response );
				},
			} );
		} );
	};

	const updateFeed = (panel) => {
		panel.html(spinner);
		setFilters();

		getData().then( data => {
			renderFeed( panel, data );
		} ).catch( console.error() );
	};

	const renderFeed = (panel, data) => {
		$( '.site-pagination').remove();
		panel.replaceWith( data );
	};

	const getStateArray = () => {
		return {
			'AL': 'Alabama',
			'AK': 'Alaska',
			'AZ': 'Arizona',
			'AR': 'Arkansas',
			'CA': 'California',
			'CO': 'Colorado',
			'CT': 'Connecticut',
			'DC': 'District of Columbia',
			'DE': 'Delaware',
			'FL': 'Florida',
			'GA': 'Georgia',
			'HI': 'Hawaii',
			'ID': 'Idaho',
			'IL': 'Illinois',
			'IN': 'Indiana',
			'IA': 'Iowa',
			'KS': 'Kansas',
			'KY': 'Kentucky',
			'LA': 'Louisiana',
			'ME': 'Maine',
			'MD': 'Maryland',
			'MA': 'Massachusetts',
			'MI': 'Michigan',
			'MN': 'Minnesota',
			'MS': 'Mississippi',
			'MO': 'Missouri',
			'MT': 'Montana',
			'NE': 'Nebraska',
			'NV': 'Nevada',
			'NH': 'New Hampshire',
			'NJ': 'New Jersey',
			'NM': 'New Mexico',
			'NY': 'New York',
			'NC': 'North Carolina',
			'ND': 'North Dakota',
			'OH': 'Ohio',
			'OK': 'Oklahoma',
			'OR': 'Oregon',
			'PA': 'Pennsylvania',
			'RI': 'Rhode Island',
			'SC': 'South Carolina',
			'SD': 'South Dakota',
			'TN': 'Tennessee',
			'TX': 'Texas',
			'UT': 'Utah',
			'VT': 'Vermont',
			'VA': 'Virginia',
			'WA': 'Washington',
			'WV': 'West Virginia',
			'WI': 'Wisconsin',
			'WY': 'Wyoming',
		}
	}

	return {
		init() {
			this.bind();
			card_type = window.card_type;
			base_url = window.base_url;
			pt = window.pt;
			console.log(card_type);
		},
		bind() {
			$('#save-filters').click(function(e) {
				let panel = $('#feed-wrapper');
				updateFeed(panel);
			});
			$('.filter-reset').click(function(e) {
				let panel = $('#feed-wrapper');
				clearFilters();
				//updateFeed(panel);
			});

		}
	};
};

filterFeed( jQuery ).init();

const authorFeed = $ => {
	let author, page, max_pages;
	let loadMore = $('#author-load-more');
	const spinner = `<div class="sk-chase">
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						  <div class="sk-chase-dot"></div>
						</div>`;

	// Get HTML
	const getData = () => {
		return new Promise( ( resolve, reject ) => {
			$.ajax( {
				type: 'GET',
				url: '/wp-json/wp/v2/authorfeed',
				data: {
					'action' : 'rest_re_get_author_posts',
					'author' : author,
					'page' : page,
				},
				success: response => {
					return resolve( response );
				},
				error: response => {
					return reject( response );
				},
			} );
		} );
	};

	const updateFeed = (panel) => {
		panel.html(spinner);

		getData().then( data => {
			renderFeed( panel, data );
		} ).catch( console.error() );
	};

	const renderFeed = (panel, data) => {
		console.log('rendered');
		console.log(page);
		console.log(max_pages);
		if (parseInt(page) === parseInt(max_pages)) {
			loadMore.hide();
		} else {
			loadMore.attr('data-paged', parseInt(page)+1);
		}
		panel.replaceWith( data );
	};

	return {
		init() {
			this.bind();
			author = window.author;
			max_pages = loadMore.attr('data-max-pages');
		},
		bind() {
			loadMore.click(function(e) {
				console.log('started');
				let panel = $('#feed-wrapper');
				page = loadMore.attr('data-paged');
				console.log('page: ' + page);
				updateFeed(panel);
			});

		}
	};
};

authorFeed( jQuery ).init();

// Accordion
/*const accordion = document.getElementById( 'faq-accordion' );
accordion.addEventListener( 'hidden.bs.collapse', function() {
	window.dispatchEvent( new Event( 'resize' ) );
} );
accordion.addEventListener( 'shown.bs.collapse', function() {
	window.dispatchEvent( new Event( 'resize' ) );
} );*/


